/**
 * Defines temporary / short-lived toggles used to control whether an in-development feature
 * is available in the environment.
 * The values for these are currently expected to come from environment variables configured in
 * the build environment. These can be defined in
 * - local development: local environment/.env files
 * - deployment builds: the amplify configuration (amplify.yml)
 *
 * TODO: One day we'd like these to be more dynamic and sourced from an API instead, so that
 * code changes & releases are not needed to enable a feature once ready & tested.
 */
export type ReleaseToggles = {};

export const getReleaseToggles = (): ReleaseToggles => ({});
